<script lang="ts" setup>
  import { ref, onMounted, watch } from 'vue'

  import SvgIcon from '@shared/components/svg-icon.vue'
  import CBtn from '@shared/components/ui/c-btn.vue'

  import type { IVisitDocumentSnapshot } from '@internal/types/visits/visit-files/visit-document-snapshot'

  const props = defineProps<{
    snapshotList: IVisitDocumentSnapshot[]
  }>()

  const emit = defineEmits<{
    (e: 'on-close'): void
    (e: 'on-delete', snapshot: IVisitDocumentSnapshot): void
  }>()
  const activeSnapshot = ref<IVisitDocumentSnapshot>()
  const close = () => {
    emit('on-close')
  }
  const changeActiveSnapshot = (snapshot: IVisitDocumentSnapshot) => {
    activeSnapshot.value = snapshot
  }

  const onDeleteHandler = () => {
    if (activeSnapshot.value) {
      emit('on-delete', activeSnapshot.value)
    }
  }

  onMounted(() => {
    if (!props.snapshotList.length) {
      return close()
    }
    activeSnapshot.value = props.snapshotList[0]
  })

  watch(
    () => props.snapshotList,
    () => {
      const isExisted = props.snapshotList.find(el => el.id === activeSnapshot?.value?.id)
      if (isExisted) {
        return
      }
      if (props.snapshotList.length) {
        activeSnapshot.value = props.snapshotList[0]
      } else {
        close()
      }
    }
  )
</script>

<template>
  <div
    class="tw-bg-white tw-transition-[width] tw-shadow-100 tw-w-full tw-h-full tw-absolute tw-top-0 md:tw-min-w-[450px] md:tw-max-w-[450px] tw-z-20 tw-flex tw-flex-col"
  >
    <div class="tw-h-[50px] tw-flex-shrink-0 tw-flex tw-items-center tw-border-b tw-border-grey-400">
      <button
        class="tw-h-[50px] tw-w-[50px] tw-flex tw-items-center tw-justify-center tw-absolute tw-left-0"
        @click="close"
      >
        <svg-icon class="tw-fill-primary-100 tw-rotate-180" name="angle-arrow" size="20" />
      </button>
      <h4 class="tw-text-headline-3 tw-mx-auto">View snapshots</h4>
    </div>
    <div class="tw-flex tw-flex-col tw-flex-grow tw-max-h-[calc(100dvh-50px-95px)]">
      <img v-if="activeSnapshot" :src="activeSnapshot.imageSrc" class="tw-my-auto tw-max-h-[70%] tw-object-contain" />
      <ul class="tw-flex tw-mt-auto tw-overflow-x-auto tw-mb-8">
        <li v-for="snapshot in snapshotList" :key="snapshot.documentId" class="tw-flex-shrink-0">
          <img
            :src="snapshot.imageSrc"
            class="tw-h-[75px] hover:tw-cursor-pointer"
            @click="changeActiveSnapshot(snapshot)"
          />
        </li>
      </ul>
    </div>
    <div
      class="md:tw-mx-16 tw-pb-50 md:tw-pb-32 tw-pt-8 md:tw-pt-24 tw-mt-auto tw-border-t tw-border-grey-400 tw-flex tw-flex-col tw-gap-8 md:tw-flex-row tw-items-center tw-shadow-600 md:tw-shadow-none md:tw-justify-between"
    >
      <c-btn size="small" class="tw-w-min tw-mx-auto" @click="onDeleteHandler">
        <svg-icon name="delete" class="tw-fill-primary-100 tw-mr-10" size="24" />
        Delete
      </c-btn>
    </div>
  </div>
</template>
